import React, { useEffect, useState } from "react";
import PageContainer from "../pages/PageContainer";
import { useParams } from "react-router-dom";
import GameSideBar from "../Games/GameSideBar";
import { getUserPerformance } from "../../api/user";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// Generate performance data for a specific range of days
// const fetchPerformanceData = (startDate, endDate) => {
//   const data = [];
//   let currentDate = new Date(startDate);

//   while (currentDate <= endDate) {
//     const performance = Math.floor(Math.random() * 201) - 100; // Random performance between -100 and 100
//     data.push({
//       date: currentDate.toISOString().split('T')[0],
//       performance,
//     });
//     currentDate.setDate(currentDate.getDate() + 1);
//   }

//   return data;
// };



const PerformanceSection = (props) => {
  const { userId } = useParams();
  const game_id = props.gameId ?? null;
  const slug = props.slug ?? null;
  const [performanceData, setPerformanceData] = useState([]);
  const [selectedRange, setSelectedRange] = useState("3 Months");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [interval, setInterval] = useState(5);

const fetchPerformanceData = async (startDate, endDate) => {
  try {
    // Fetch performance data from the backend API
    const response = await getUserPerformance(userId, startDate, endDate);

    // Get the performance data from the response
    const data1 = response.data; // Assuming 'data' contains the performance records from backend

    const data = [];

    // Transform the API response into the desired format
    data1.forEach(item => {
      const performance = Math.round(parseFloat(item.performance)); // Round performance to nearest integer
      const dateObj = new Date(item.performance_updated_at); // Parse the performance_updated_at date
      dateObj.setDate(dateObj.getDate() + 1); // Add one day
      //const date = dateObj.toISOString().split('T')[0]; // Extract the date in 'YYYY-MM-DD' format
      const date = item.performance_updated_at.split(' ')[0];

      // Push transformed data into the array
      data.push({
        date: date,
        performance // Store performance as an integer
      });
    });

    // Ensure data is sorted by date (if not already sorted)
    data.sort((a, b) => new Date(a.date) - new Date(b.date));

    console.log(data, 'tarun'); // Log the transformed data with the label "tarun"

    return data; // Return the transformed data in the correct format
  } catch (error) {
    console.error("Error fetching performance data:", error);
    return []; // Return an empty array in case of error
  }
};




useEffect(() => {
  const fetchFilteredData = async () => {
    try {
      const filteredData = await filterDataByRange(selectedRange, startDate, endDate); // Wait for the data
      console.log(filteredData, 'filteredData');
      setPerformanceData(filteredData);

      let dataLength = filteredData.length;
      if (selectedRange === "This Month" || selectedRange === "Last 1 Month") {
        setInterval(15);
      } else if (selectedRange === "3 Months") {
        setInterval(12);
      } else if (selectedRange === "6 Months") {
        setInterval(30);
      }else if (selectedRange === "12 Months") {
        setInterval(30);
      }
      else {
        setInterval(dataLength > 30 ? 100 : 5); // Adjust interval based on number of data points
      }
    } catch (error) {
      console.error("Error filtering data:", error);
    }
  };

  fetchFilteredData();
}, [selectedRange, startDate, endDate]);

  const filterDataByRange = (range, start, end) => {
    let data = [];
    const today = new Date();

    if (range === "This Month") {
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      data = fetchPerformanceData(firstDayOfMonth, today);
    } else if (range === "Last 1 Month") {
      const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const lastDayOfLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      data = fetchPerformanceData(firstDayOfLastMonth, lastDayOfLastMonth);
    } else if (range === "3 Months") {
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      data = fetchPerformanceData(threeMonthsAgo, today);
    } else if (range === "6 Months") {
      const sixMonthsAgo = new Date();
      sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
      data = fetchPerformanceData(sixMonthsAgo, today);
    } else if (range === "12 Months") {
      const tweleveMonthsAgo = new Date();
      tweleveMonthsAgo.setMonth(tweleveMonthsAgo.getMonth() - 12);
      data = fetchPerformanceData(tweleveMonthsAgo, today);
    }
     else {
      data = fetchPerformanceData(start, end);
    }
    return data;
  };

  const isUniformData = performanceData.every(item => item.performance === performanceData[0].performance);

const lineStroke = isUniformData ? "grey" : "url(#colorPerformance)";


  return (
    <>
      <PageContainer gamePage={game_id && true}>
        {slug && <GameSideBar slug={slug} />}
    <div className="chart-container">
    <div className="flex gap-3 items-center flex-wrap max-md:justify-center max-md:gap-0 max-md:mb-3">
      <div className="dropdown">
        <select className="bg-primaryColor appearance-none bg-[url(images/arrowWhite.svg)] bg-[right_10px_center] bg-no-repeat my-4 text-white outline-none h-10 rounded-full px-3 pr-7" value={selectedRange} onChange={(e) => setSelectedRange(e.target.value)}>
          <option value="This Month">This Month</option>
          <option value="Last 1 Month">Last 1 Month</option>
          <option value="3 Months">Last 3 Months</option>
          <option value="6 Months">Last 6 Months</option>
          <option value="12 Months">Last 12 Months</option>
          <option value="Custom">Custom Date Range</option>
        </select>
      </div>

      {selectedRange === "Custom" && (
        <div className="date-picker flex border rounded-xl py-2 px-4 items-center">
        <div>
          <label className="font-semibold">Start Date: </label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            maxDate={endDate}
            width={100}
          />
        </div>
        <span className="pr-8 text-nowrap">-&gt;</span>
        <div>
          <label className="font-semibold">End Date: </label>
          <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            maxDate={new Date()}
          />
        </div>
        </div>
      )}
    </div>

      <ResponsiveContainer width="100%" height={650}>
        <LineChart
          data={performanceData}
          margin={{ top: 20, right: 30, left: 0, bottom: 50 }}
        >
          <defs>
            <linearGradient id="colorPerformance" x1="0" y1="0" x2="0" y2="1">
              <stop offset="50%" stopColor="green" stopOpacity={1} />
              <stop offset="50%" stopColor="red" stopOpacity={1} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          {/* <XAxis
            dataKey="date"
              // tickFormatter={(date) => new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric" })}
            interval={interval} // Dynamic interval
            tick={{ angle: 0, textAnchor: 'start' }} // Rotate X-axis labels to avoid overlapping
          /> */}

<XAxis
  dataKey="date"
  ticks={
    performanceData?.length > 0
      ? [performanceData[0]?.date, performanceData[performanceData.length - 1]?.date]
      : []
  }
  tickFormatter={(value) => value}
  interval="preserveStartEnd"
/>





          {/* <YAxis
            domain={[-100, 50]}
            tickFormatter={(value) => `${value}%`}
            connectPoints={true}
          /> */}
{/* <YAxis
  domain={[
    performanceData.length > 0
      ? Math.min(...performanceData.map((item) => item.performance)) - 10
      : -100,
    performanceData.length > 0
      ? Math.max(...performanceData.map((item) => item.performance)) + 10
      : 50
  ]}
  tickFormatter={(value) => `${value}%`}
  connectPoints={true}
/> */}

{/* <YAxis
  domain={[
    performanceData.length > 0
      ? Math.floor(Math.min(...performanceData.map((item) => item.performance)) / 10) * 10
      : -100,  // Adjust to 10-unit intervals
    performanceData.length > 0
      ? Math.ceil(Math.max(...performanceData.map((item) => item.performance)) / 10) * 10
      : 50     // Adjust to 10-unit intervals
  ]}
  ticks={Array.from(
    { length: Math.ceil((Math.max(...performanceData.map(item => item.performance)) - Math.min(...performanceData.map(item => item.performance))) / 10) + 1 },
    (_, index) => Math.min(...performanceData.map(item => item.performance)) + (index * 10)
  )}
  tickFormatter={(value) => `${value}%`} // Format Y-axis ticks as percentage
  connectPoints={true}
/> */}

{/* <YAxis
  domain={[
    performanceData.length > 0
      ? Math.floor(Math.min(...performanceData.map((item) => item.performance)) / 10) * 10
      : -100, // Adjust to nearest lower 10
    performanceData.length > 0
      ? Math.ceil(Math.max(...performanceData.map((item) => item.performance)) / 10) * 10
      : 50   // Adjust to nearest upper 10
  ]}
  tickCount={Math.ceil((Math.max(...performanceData.map(item => item.performance)) - Math.min(...performanceData.map(item => item.performance))) / 10) + 1}
  interval={0}
  tickFormatter={(value) => `${value}%`}
/> */}

{/* <YAxis
  domain={[
    performanceData.length > 0
      ? Math.floor(Math.min(...performanceData.map((item) => item.performance)) / 10) * 10
      : -100,
    performanceData.length > 0
      ? Math.ceil(Math.max(...performanceData.map((item) => item.performance)) / 10) * 10
      : 50
  ]}
  ticks={[
    ...new Set(performanceData.map((item) => item.performance)), // Unique performance values
    ...Array.from(
      { length: Math.ceil((Math.max(...performanceData.map(item => item.performance)) - Math.min(...performanceData.map(item => item.performance))) / 10) + 1 },
      (_, index) => Math.floor(Math.min(...performanceData.map(item => item.performance)) / 10) * 10 + (index * 10)
    ) // Ensuring 10-unit interval
  ].sort((a, b) => a - b)} // Sort all values in ascending order
  tickFormatter={(value) => `${value}%`}
/> */}

<YAxis
  domain={[
    performanceData.length > 0
      ? Math.floor(Math.min(...performanceData.map((item) => item.performance)) / 10) * 10
      : -100,
    performanceData.length > 0
      ? Math.ceil(Math.max(...performanceData.map((item) => item.performance)) / 10) * 10
      : 50
  ]}
  ticks={[
    ...new Set(performanceData.map((item) => item.performance)), // Unique performance values
    ...Array.from(
      { length: Math.ceil((Math.max(...performanceData.map(item => item.performance)) - Math.min(...performanceData.map(item => item.performance))) / 10) + 1 },
      (_, index) => Math.floor(Math.min(...performanceData.map(item => item.performance)) / 10) * 10 + (index * 10)
    ) // Ensuring 10-unit gaps
  ].sort((a, b) => a - b)} // Sorting in ascending order
  tickFormatter={(value) => `${value}%`}
/>











          <Tooltip
          formatter={(value) => `${value}%`}
            wrapperStyle={{
              backgroundColor: 'rgba(0, 0, 0, 0.6)',
              borderRadius: '4px',
              padding: '8px',
            }} // Make the tooltip background darker with rounded corners
            contentStyle={{
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
              color: 'white',
              fontSize: '12px',
            }} // Tooltip content style
          />
        <ReferenceLine y={0} stroke="#000000" strokeWidth={0.7} />




          <Line
            type="monotone"
            dataKey="performance"
            stroke={lineStroke}
            strokeWidth={2}
            dot={{ r: 3, stroke: "#8884d8", strokeWidth: 2 }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
      </PageContainer>
    </>
  );
};

export default PerformanceSection;
